import request, { METHODS } from "src/utils/api-base";

export interface CreateTransactionPayload {
  amount: number | string;
  transactionType: "payment" | "refund";
  status: "created" | "processing" | "success" | "failed";
  referenceId?: string;
  remarks?: string;
  data?: string;
}

const transactionApis = {
  createTransaction: (payload: CreateTransactionPayload) => {
    return request({
      route: "/admin/transaction/create",
      method: METHODS.POST,
      payload,
      auth: true,
      isAdminAuth: true,
    });
  },
  getTransactionList: (params: { page: number; limit: number }) => {
    return request({
      route: "/admin/transaction/list",
      method: METHODS.GET,
      params,
      auth: true,
      isAdminAuth: true,
    });
  },
  getTransactionDetails: (id: string) => {
    return request({
      route: `/admin/transaction/${id}`,
      method: METHODS.GET,
      auth: true,
      isAdminAuth: true,
    });
  },
  editTransaction: (payload: { id: string; data: CreateTransactionPayload }) => {
    return request({
      route: `/admin/transaction/${payload.id}`,
      method: METHODS.PUT,
      payload: payload.data,
      auth: true,
      isAdminAuth: true,
    });
  },
};

export default transactionApis;
